<template>
    <multiselect
        v-model="value"
        track-by="name"
        label="name"
        placeholder="Select one"
        selectLabel=""
        selectedLabel=""
        deselectLabel=""
        v-bind:options="options"
        v-bind:multiple="true"
        v-bind:close-on-select="false"
        v-bind:clear-on-select="false"
        v-bind:searchable="false"

    >
        <template slot="selection" slot-scope="{ values, search, isOpen }">
            <span
                v-if="values.length > (maxCount || 5) && !isOpen"
                v-bind:class="{'someselected': values.length !== options.length}"
            >{{ values.length }} {{ filterTypePlural || 'options' }} selected</span>
            <span
                v-else-if="values.length && !isOpen"
                v-bind:class="{'someselected': values.length !== options.length}"
            >{{ values.map(x => x.name).join(', ') }}</span>
        </template>
        <template slot="tag" slot-scope={}><span></span></template>
        <template slot="beforeList" slot-scope={}>
            <div class="button-set">
                <button v-on:click="selectAll"
                        title="Select all options in this category"
                        >Select All
                </button>
            </div>
        </template>
    </multiselect>
</template>

<script>
export default {
    name: "Dropdown",
    props: ['options', 'maxCount', 'filterTypePlural', 'selected', 'clear'],
    data: function () {

        return {
            value: [],
        }
    },
    watch: {
        options: {
            immediate: true,
            handler: function () {
                if (this.options && this.options.length) {
                    if (this.selected && this.selected.length) {
                        this.value = this.options.filter(o => this.selected.includes(o.name));
                    } else {
                        this.value = this.options;
                    }

                }
            }
        },
        value: function (new_val, old_val) {
            if (new_val.length === 0 && old_val.length === 1) {
                let old_name = old_val[0].name;
                this.value = this.options.filter(x => x.name !== old_name);
            } else if (new_val.length === (this.options.length - 1) && old_val.length === this.options.length) {
                this.options.forEach(x => {
                    if (!new_val.includes(x)) {
                        this.value = [x]
                    }
                });
            }
            if (this.value.length === this.options.length) {
                this.$emit("input", [])
            } else {
                let value = this.value.map(v => v.statevalue || v.name);
                value.sort()
                if (value.length) {
                    this.$emit("input", value);
                }
            }
        },
        clear: function() {
            if(this.clear && !this.allSelected) {
                this.selectAll();
            }
        }
    },
    methods: {
        selectAll() {
            this.value = this.options;
        },
    },
    computed: {
        allSelected: function () {
            return (this.value.length === this.options.length);
        }
    }
}

</script>

<style scoped>

/deep/ .multiselect__tags:first-child {
    display: none;
}
/deep/ .multiselect__option--selected.multiselect__option--highlight {
    background: #41b883;
}

/deep/ .multiselect__option--selected.multiselect__option--highlight:after {
    background: #41b883;
}

/deep/ .multiselect__option--group-selected.multiselect__option--highlight {
    background: #41b883;
}

/deep/ .multiselect__option--group-selected.multiselect__option--highlight:after {
    background: #41b883;
}

/deep/ .multiselect__option > span:before {
    content: "☐ ";
}

/deep/ .multiselect__option--selected > span:before {
    content: "☑ ";
}

div {
    margin: 3px 0;
    min-width: 0;
}

.someselected {
    font-weight: bold;
    color: #000;
}
button {
    width: 100%;
    font-size: large;
}

button:hover {
    cursor: pointer;
}

.button-set {
    width: 100%;
    padding: 3px;
}

</style>
